// src/components/common/Logo.js
import { useTheme } from "../../contexts/ThemeContext";

export default function Logo({ className = "" }) {
  const { theme } = useTheme();
  const isDark = theme === 'dark';
  
  const primaryColor = isDark ? '#93c5fd' : '#1d4ed8';
  const secondaryColor = isDark ? '#818cf8' : '#2563eb';
  const accentColor = isDark ? '#38bdf8' : '#3b82f6';
  const panelStroke = isDark ? 'rgba(148, 163, 184, 0.18)' : 'rgba(15, 23, 42, 0.1)';
  
  return (
    <div className={`logo-container ${className}`}>
      <svg
        width="48"
        height="48"
        viewBox="0 0 48 48"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        className="logo-svg"
      >
        <defs>
          <linearGradient id="logoGradient" x1="0%" y1="0%" x2="100%" y2="100%">
            <stop offset="0%" stopColor={primaryColor} />
            <stop offset="55%" stopColor={secondaryColor} />
            <stop offset="100%" stopColor={accentColor} />
          </linearGradient>
          <linearGradient id="logoCoreGradient" x1="10" y1="10" x2="38" y2="38">
            <stop offset="0%" stopColor={isDark ? 'rgba(15, 23, 42, 0.16)' : 'rgba(255, 255, 255, 0.92)'} />
            <stop offset="100%" stopColor={isDark ? 'rgba(15, 23, 42, 0.72)' : 'rgba(255, 255, 255, 0.52)'} />
          </linearGradient>
        </defs>

        <rect
          x="4"
          y="4"
          width="40"
          height="40"
          rx="14"
          fill="url(#logoGradient)"
          opacity="0.16"
        />

        <path
          d="M11 18.5C11 14.3579 14.3579 11 18.5 11H29.5C33.6421 11 37 14.3579 37 18.5V29.5C37 33.6421 33.6421 37 29.5 37H18.5C14.3579 37 11 33.6421 11 29.5V18.5Z"
          fill="url(#logoCoreGradient)"
          stroke={panelStroke}
        />
        <path
          d="M15.5 27.5L21 22L24.5 25.5L32.5 17.5"
          stroke="url(#logoGradient)"
          strokeWidth="3"
          strokeLinecap="round"
          strokeLinejoin="round"
          fill="none"
        />
        <circle cx="15.5" cy="16" r="1.8" fill={primaryColor} opacity="0.9" />
        <circle cx="32.5" cy="31.5" r="2.2" fill={secondaryColor} opacity="0.8" />
        <path
          d="M26 13.5H32"
          stroke={accentColor}
          strokeWidth="2"
          strokeLinecap="round"
          opacity="0.8"
        />
      </svg>
    </div>
  );
}
